/**
 * 打印 / 导出 公共 mixin
 * 页面只需：给表格加 id，按钮调 this.doPrint / this.doExport
 *
 * 用法：
 *   import ioMixin from '../../js/common/io-mixin'
 *   export default { mixins: [ioMixin], methods: {
 *     printPage() { this.doPrint({title: '序时账', elId: 'tsTable'}) },
 *     exportExcel() { this.doExport({name: '序时账', elId: 'tsTable'}) }
 *   }}
 */
import moment from 'moment';
import { printTable } from './print';
import { exportXls, parseTable } from './export';

const DEFAULT_SIGN = [{ name: '主管', value: '' }, { name: '记账', value: '' }, { name: '审核', value: '' }, { name: '出纳', value: '' }];

export default {
	computed: {
		companyName() {
			let s = (this.$store && this.$store.state) ? this.$store.state.currentAccountSets : null;
			return s ? (s.name || s.accountSetsName || '') : '';
		},
		periodText() {
			return this.fmtPeriod(this.accountDate);
		}
	},
	methods: {
		fmtPeriod(d) {
			if (!d) return '';
			return moment(d).format('YYYY年MM期');
		},
		fmtDate(d) {
			if (!d) return '';
			return moment(d).format('YYYY-MM-DD');
		},
		doPrint(opt) {
			const el = document.getElementById(opt.elId);
			if (!el) {
				this.$Message('暂无数据可打印');
				return;
			}
			printTable({
				title: opt.title,
				subTitle: opt.subTitle || '',
				company: opt.company == null ? this.companyName : opt.company,
				period: opt.period || this.periodText,
				elementId: opt.elId,
				landscape: !!opt.landscape,
				paper: opt.paper || 'A4',
				fontSize: opt.fontSize || 12,
				sign: opt.sign === false ? false : (opt.sign || DEFAULT_SIGN),
				footNote: opt.footNote || '',
				styleExtra: opt.styleExtra || ''
			});
		},
		doExport(opt) {
			const r = parseTable(opt.elId);
			if (!r.rows.length) {
				this.$Message('暂无数据可导出');
				return;
			}
			exportXls({
				name: `${opt.name}_${opt.period || this.periodText || ''}`.replace(/_\s*$/, ''),
				sheets: [{
					name: (opt.sheetName || opt.name || 'Sheet1').substring(0, 31),
					head: r.head,
					rows: r.rows,
					widths: opt.widths,
					totalRow: opt.totalRow
				}]
			});
		}
	}
};
